import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {HotspotCreatorService} from '../../../service/http/hotspot-creator.service';

@Component({
  selector: 'app-delete-hotspot-template',
  templateUrl: './delete-hotspot-template.component.html',
  styleUrls: ['./delete-hotspot-template.component.css']
})
export class DeleteHotspotTemplateComponent implements OnInit {

  hotspotTemplateList: string[];
  hotspotTemplateLoadName: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<DeleteHotspotTemplateComponent>,
              private hotspotCreatorService: HotspotCreatorService) { }

  ngOnInit() {
    this.hotspotTemplateList = this.data.hotspotTemplateList;
  }

  deleteHotspotTemplate() {
    if(this.hotspotTemplateLoadName !== undefined) {
      this.hotspotCreatorService.deleteHotspotTemplate(this.hotspotTemplateLoadName).subscribe();
      this.dialogRef.close({hotspotTemplateDeleted: true});
    }
  }
}
